import { AddWarehouseToCarrier } from "components/AGTable/NewColumns/AddWarehouseToCarrier";
import {
  NameColumnDef,
  EmailColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  FaxColumnDef,
  ContactColumnDef,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  cellStyle: { display: "flex", "justify-content": "center" },
  filter: true,
};

export const warehouseGrid = {
  columnDefs: [
    AddWarehouseToCarrier,
    {
      headerName: "Vendor",
      field: "vendor.name",
      width: 200,
    },
    NameColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zip"),
    {
      headerName: "Distance (mi)",
      width: 130,
      field: "distance",
    },
    PhoneColumnDef,
    EmailColumnDef,
    FaxColumnDef,
    ContactColumnDef,
  ],
  defaultColDef,
};
